import React from 'react'
import './HeroBadge.css'
function HeroBadge({ text, className, as: Component = "div", children, ...props }) {
    const badgeClassName = ['hero-badge', className].filter(Boolean).join(' ')

    return (
        <Component className={badgeClassName} {...props}>
            <span className="hero-badge__dot" aria-hidden="true" />
            {children ?? text}
        </Component>

    )
}

export default HeroBadge
